export default __webpack_public_path__ + "static/media/qrcode-site-480w.ba2f5b6b.png";